import React from 'react';
import { isExternalAgent, agentModelName, isMaintainer } from '../../utils/playerKind';

// 🎭 Cast rail — the space's characters front and center (Nina 07-11: the
// sidebar chat room leads with WHO is here, Tea-style mini polaroids, before
// what they're saying). Host card first, then the seats.

const CastRail = ({ users = [], moderatorCharacter, humanPlayerId, getModelName, THEME }) => {
  const cast = [];
  if (moderatorCharacter) {
    cast.push({
      key: 'host',
      name: moderatorCharacter.name || 'The Host',
      img: moderatorCharacter.profile_image_url,
      emoji: moderatorCharacter.avatar_emoji || '🎙️',
      badge: '🎙️ HOST',
    });
  }
  users.forEach((u, i) => {
    const model = getModelName ? getModelName(u) : null;
    const isYou = humanPlayerId && (u.game_player_id === humanPlayerId || u.id === humanPlayerId);
    // 🤖 An external agent seat carries is_human:true for engine reasons
    // (utils/playerKind) and its `model` column is null, so it fell through to
    // BOTH fallbacks and this rail captioned a probe "🧑 Human". Agents get
    // their own model + marker; the name above is the one they picked at join.
    const agent = isExternalAgent(u);
    const badge = agent
      ? (agentModelName(u) || '🤖 agent')
      : (model && model !== 'Human Player' ? model : '🧑 Human');
    cast.push({
      key: u.game_player_id || u.id || `u${i}`,
      name: isYou ? 'You' : (u.name || 'Player'),
      img: u.profile_image_url || u.data?.profile_image_url,
      emoji: agent ? '🤖' : '🙂',
      badge,
      // 🔧 Admin seat (09-01): server-stamped via checkAdminAuth at join.
      subBadge: agent ? '🤖 visiting' : (isMaintainer(u) ? '🔧 maintenance' : null),
      isYou,
    });
  });

  if (cast.length === 0) return null;

  return (
    <div style={{ padding: '10px 6px 4px' }}>
      <div style={{
        fontSize: '0.62em', fontWeight: 800, letterSpacing: '1.2px', textTransform: 'uppercase',
        color: THEME?.textMuted || '#aaa', padding: '0 4px 8px',
      }}>
        🎭 The locals
      </div>
      <div className="cast-rail-scroll" style={{ display: 'flex', gap: 10, overflowX: 'auto', padding: '4px 4px 10px', scrollbarWidth: 'none' }}>
        <style>{`.cast-rail-scroll::-webkit-scrollbar { display: none; }`}</style>
        {cast.map((c, i) => (
          <div key={c.key} style={{
            flexShrink: 0, width: 84,
            transform: `rotate(${i % 2 === 0 ? -2 : 2}deg)`,
            backgroundColor: '#faf7f0', borderRadius: 3, padding: '5px 5px 6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            outline: c.isYou ? `2px solid ${THEME?.accent || '#7b1fa2'}` : 'none',
          }}>
            <div style={{
              width: '100%', aspectRatio: '1 / 1', borderRadius: 2, overflow: 'hidden',
              backgroundColor: '#1a1a2e', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              {c.img ? (
                <img src={c.img} alt="" loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => { e.target.style.display = 'none'; }} />
              ) : (
                <span style={{ fontSize: '1.6em' }}>{c.emoji}</span>
              )}
            </div>
            <div style={{
              fontSize: '0.6em', fontWeight: 700, color: '#2a2a2a', textAlign: 'center',
              marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{c.name}</div>
            <div style={{
              fontSize: '0.5em', fontWeight: 600, color: '#8a8a8a', textAlign: 'center',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{c.badge}</div>
            {/* Own line — this polaroid is 84px wide and one line carrying the
                model slug AND the marker ellipsized the model into nothing. */}
            {c.subBadge && (
              <div style={{
                fontSize: '0.46em', fontWeight: 700, color: '#7b5ea7', textAlign: 'center',
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>{c.subBadge}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(CastRail);
